// Minimal local replacement for AntD's ConfigProvider.
export const ConfigProvider = ({ children /* theme, locale, direction, ...rest */ }) => {
  return <>{children}</>;
};

export default ConfigProvider;
